export default __webpack_public_path__ + "static/media/RedCloseSquare.567f899d.svg";